export default __webpack_public_path__ + "static/index-title-news-zh-Hant-78b6d4b93ec46a8bbc4bc81f1aa38233.png";